<template>
  <agent-ad-revenue v-if="isAgent" />
  <ad-revenue-query v-else />
</template>

<script>
import AdRevenueQuery from './AdRevenueQuery.vue'
import AgentAdRevenue from './AgentAdRevenue.vue'

export default {
  name: 'AdRevenueEntry',
  components: { AdRevenueQuery, AgentAdRevenue },
  computed: {
    isAgent() {
      return parseInt(localStorage.getItem('role'), 10) === 2
    }
  }
}
</script>
